import(/* webpackMode: "eager" */ "/codebuild/output/src316224838/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
